function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M134.163 93.541H65.836c-.7 0-1.245.545-1.245 1.245v11.518c0 .7.545 1.245 1.245 1.245h25.915v35.097c0 .7.545 1.245 1.245 1.245h14.163a1.23 1.23 0 001.246-1.245v-35.097h25.914c.7 0 1.245-.545 1.245-1.245V94.786c-.156-.7-.7-1.245-1.401-1.245zM100 77.198c5.837 0 10.506-4.747 10.506-10.506 0-5.836-4.747-10.505-10.506-10.505-5.837 0-10.506 4.747-10.506 10.505 0 5.837 4.67 10.506 10.506 10.506z",
  fill: "#080503"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M100 0C44.747 0 0 44.747 0 100s44.747 100 100 100 100-44.747 100-100S155.253 0 100 0zm61.323 161.323c-16.42 16.42-38.21 25.447-61.323 25.447s-44.98-9.027-61.323-25.447C22.257 144.981 13.23 123.191 13.23 100c0-23.19 9.027-44.98 25.447-61.323C55.02 22.257 76.809 13.23 100 13.23c23.191 0 44.981 9.027 61.323 25.447 16.42 16.42 25.447 38.21 25.447 61.323 0 23.191-9.027 44.981-25.447 61.323z",
  fill: "#080503"
});

function SvgTBtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTBtc);
export default __webpack_public_path__ + "static/media/tBTC.5a906845.svg";
export { ForwardRef as ReactComponent };